export default function importFirebase() {
  // eslint-disable-next-line import/no-extraneous-dependencies
  return Promise.all([import('firebase/app'), import('firebase/auth')]);
}
